import { fork } from 'redux-saga/effects';

import { actions } from 'domain/subject';
import { itemNavigator } from 'sagas/common';
import { editableFields } from './index';

export default function* navigator(args) {
  yield fork(itemNavigator, { modelName: 'Subject', actions, editableFields }, args);
}
